/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargo_Available_BagsInputs */

const en_cargo_available_bags = /** @type {(inputs: Cargo_Available_BagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Available Bags`)
};

const es_cargo_available_bags = /** @type {(inputs: Cargo_Available_BagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bolsas disponibles`)
};

/**
* | output |
* | --- |
* | "Available Bags" |
*
* @param {Cargo_Available_BagsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargo_available_bags = /** @type {((inputs?: Cargo_Available_BagsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargo_Available_BagsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargo_available_bags(inputs)
	return es_cargo_available_bags(inputs)
});